// extracted by mini-css-extract-plugin
export default {"title":"residential-address-form-module__title--eh1","checkbox":"residential-address-form-module__checkbox--lG6"};